import { render, staticRenderFns } from "./UserLocationModal.vue?vue&type=template&id=dda109bc"
import script from "./UserLocationModal.vue?vue&type=script&lang=js"
export * from "./UserLocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports